import React, { memo, useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import ModelTag, { ModelTagStyle } from '../../components/model-tag';

import './customization-page.css';

interface ModelTagsProps {
    tags: string[];
    onToggle?: (tag: string) => void;
    activeTags?: string[];
}

const ModelTags = (props: ModelTagsProps) => {
    const { tags, onToggle, activeTags = [] } = props;

    const { t } = useTranslation();

    const handleClick = useCallback((tag: string) => {
        if (onToggle) {
            onToggle(tag);
        }
    }, [onToggle]);

    // Memoize activeTags as a Set for O(1) lookup performance
    const activeTagsSet = useMemo(() => new Set(activeTags), [activeTags]);

    return (
        <span className="model-tags">
            <span className="model-tags-label">
                {t('customizationPage.modelTags')}:
            </span>
            {tags.map(tag => {
                const isTagActive = activeTagsSet.has(tag);
                return (
                    <span key={tag} className="model-tag-container">
                        <ModelTag
                            allowTextSelect
                            style={ModelTagStyle.Highlighted}
                            onClick={handleClick}
                            isActive={isTagActive}
                        >
                            {tag}
                        </ModelTag>
                    </span>
                );
            })}
        </span>
    );
}

export default memo(ModelTags);
